import { useRouter } from "expo-router";

import { authClient } from "~/utils/auth";

export const useCreateLogout = () => {
  const router = useRouter();

  const logout = () => {
    return authClient.signOut({
      fetchOptions: {
        onSuccess: () => {
          router.push("/auth");
        },
      },
    });
  };

  return { logout };
};
